const banners = [
  {
    id: "63473b39f890e0e22023a736",
    name: "CCI Ago Inaugural Service",
    subtitle: "Hillcrest Events Center, 46 Ago Palace Way, Lagos, Nigeria.",
    imageUrl: "https://res.cloudinary.com/cci-global/image/upload/v1665612430/cci-get-dp/production/events/cci-ago-inaugural-service_tfxtlt.png",
    baseImageUrl: "https://res.cloudinary.com/cci-global/image/upload/v1665612429/cci-get-dp/production/events/cci-ago-getdp-banner_a4ce8y.png",
    numberOfViews: 211,
    numberOfDps: 209,
    visibility: "PUBLIC",
    avatarShape: "CIRCLE",
    slug: "cci-ago-inaugural-service",
    url: "ago",
    description: "<div><p>Do you live in or around Ago palace way? Celebration Church International is coming to your neighbourhood. 💃💃</p><p>You're invited to be a part of this move of God. The gospel prevails in Ago and its environs!</p><p>Our inaugural service holds 9 am this Sunday, 16th October 2022. </p><p>Venue: Hillcrest event center, 46 Ago palace way, Lagos.</p><p>You can also make a DP to invite someone to our inaugural service.</p><p>See you there! 🤗🤗</p></div>",
    imagePosition: {
      x: "226",
      y: "100",
      height: "250",
      width: "250",
      compassPosition: "north_west",
      fontFamily: null,
      fontSize: null,
      fontWeight: null,
      fontStyle: null,
      textDecoration: null,
      textColor: null,
      align: null
    },
    usernamePosition: null,
    eventDate: "2022-10-16T00:00:00.000Z"
  },
  {
    id: "636ec1c26713edce5f61e865",
    name: "CCI Is 10",
    subtitle: "The Konga Place, 4 Oba Elegushi Beach Road, Lekki.",
    imageUrl: "https://res.cloudinary.com/cci-global/image/upload/v1668183819/cci-get-dp/production/events/cci-at-10_jkqshh.jpg",
    baseImageUrl: "https://res.cloudinary.com/cci-global/image/upload/v1668183819/cci-get-dp/production/events/cci-at-10-banner_uhdig1.jpg",
    numberOfViews: 2123,
    numberOfDps: 1991,
    visibility: "PUBLIC",
    avatarShape: "SQUARE",
    slug: "cciat10",
    url: "cciat10",
    description: "<div><p>CCI is 10 🎉🎉🎉</p><p>To celebrate 10 years of God's faithfulness, join us at our special anniversary service this Sunday, 13th November by 12pm WAT at The Konga Place, 4 Oba Elegushi Beach Road, Lekki.</p><p>This is not a service to miss so make sure you make plans to attend and remember to bring a friend along 😉.</p><p>#CCI10 #1B10K</p></div>",
    imagePosition: {
      x: "244",
      y: "142",
      height: "268",
      width: "208",
      compassPosition: "north_west",
      fontFamily: null,
      fontSize: null,
      fontWeight: null,
      fontStyle: null,
      textDecoration: null,
      textColor: null,
      align: null
    },
    usernamePosition: {
      x: "0",
      y: "450",
      height: "40",
      width: "703",
      compassPosition: "north_west",
      fontFamily: "Lato",
      fontSize: "25",
      fontWeight: "medium",
      fontStyle: null,
      textDecoration: null,
      textColor: "white",
      align: "center"
    },
    eventDate: "2022-11-13T00:00:00.000Z"
  },
  {
    id: "6387c5b555cbfa9fa018d7cd",
    name: "CCI Reboot Camp 2022",
    subtitle: "Konga Place, 5 Oba Elegushi Beach Road, Off Lekki Epe Express Way. Lekki, Lagos, Nigeria.",
    imageUrl: "https://res.cloudinary.com/cci-global/image/upload/v1669827289/cci-get-dp/production/events/cci-reboot-camp-22.jpg",
    baseImageUrl: "https://res.cloudinary.com/cci-global/image/upload/v1669827295/cci-get-dp/production/events/cci-reboot-camp-22-banner.png",
    numberOfViews: 1759,
    numberOfDps: 1723,
    visibility: "PUBLIC",
    avatarShape: "SQUARE",
    slug: "rc-22",
    url: "rc-22",
    description: "<div><p>Are you ready for a lifetime experience?! 💃🏼</p><p>It's few days to the Global Reboot Camp Meeting #Contagious 🔥</p><p>Spread the word! Tell everyone you know.</p><p>Invite your friends and family for a R.I.C.H experience. 🫂❤️\u200d🔥</p><p><strong>Pray...Plan...Prepare.</strong></p><p>See you at Reboot Camp 2022 😊</p><p><a href=\"https://therebootcamp.ccing.org/\" target=\"_blank\">#ccirebootcamp</a> <a href=\"https://instagram.com/cci_therebootcamp\" target=\"_blank\">#rebootcamp22</a></p></div>",
    imagePosition: {
      x: "376",
      y: "397",
      height: "350",
      width: "326",
      compassPosition: "north_west",
      fontFamily: null,
      fontSize: null,
      fontWeight: null,
      fontStyle: null,
      textDecoration: null,
      textColor: null,
      align: null
    },
    usernamePosition: {
      x: "376",
      y: "760",
      height: "40",
      width: "326",
      compassPosition: "north_west",
      fontFamily: "Expose.ttf",
      fontSize: "28",
      fontWeight: "normal",
      fontStyle: null,
      textDecoration: "uppercase",
      textColor: "white",
      align: "lpad"
    },
    eventDate: "2022-12-09T00:00:00.000Z"
  },
  {
    id: "638a0d1e16ed1c60f66321e7",
    name: "CCI Reboot Camp '22",
    subtitle: "Konga Place, 5 Oba Elegushi Beach Road, Off Lekki Epe Express Way. Lekki, Lagos, Nigeria.",
    imageUrl: "https://res.cloudinary.com/cci-global/image/upload/v1669990676/cci-get-dp/production/events/cci-reboot-camp-22-02.jpg",
    baseImageUrl: "https://res.cloudinary.com/cci-global/image/upload/v1669990676/cci-get-dp/production/events/cci-reboot-camp-22-02-banner.jpg",
    numberOfViews: 45,
    numberOfDps: 44,
    visibility: "PUBLIC",
    avatarShape: "SQUARE",
    slug: "reboot-22",
    url: "reboot-22",
    description: "<div><p>Are you ready for a lifetime experience?! 💃🏼</p><p>It's few days to the Global Reboot Camp Meeting #Contagious 🔥</p><p>Spread the word! Tell everyone you know.</p><p>Invite your friends and family for a R.I.C.H experience. 🫂❤️\u200d🔥</p><p><strong>Pray...Plan...Prepare.</strong></p><p>See you at Reboot Camp 2022 😊</p><p><a href=\"https://therebootcamp.ccing.org/\" target=\"_blank\">#ccirebootcamp</a> <a href=\"https://instagram.com/cci_therebootcamp\" target=\"_blank\">#rebootcamp22</a></p></div>",
    imagePosition: {
      x: "221",
      y: "93",
      height: "261",
      width: "261",
      compassPosition: "north_west",
      fontFamily: null,
      fontSize: null,
      fontWeight: null,
      fontStyle: null,
      textDecoration: null,
      textColor: null,
      align: "38"
    },
    usernamePosition: {
      x: "300",
      y: "400",
      height: "40",
      width: "350",
      compassPosition: "north_west",
      fontFamily: "Expose.ttf",
      fontSize: "30",
      fontWeight: "bold",
      fontStyle: null,
      textDecoration: "uppercase",
      textColor: "white",
      align: "fit"
    },
    eventDate: "2022-12-09T00:00:00.000Z"
  },
  {
    id: "63c0151cd3bd3e7cb38beb8b",
    name: "CCI Uyo Inaugural Service",
    subtitle: "Silverbird Cinemas Hall 1, Ibom Tropicana Entertainment Centre, Uyo, Akwa Ibom State, Nigeria.",
    imageUrl: "https://res.cloudinary.com/cci-global/image/upload/v1673526492/cci-get-dp/production/events/cci-uyo-inaugural-service-main.jpg",
    baseImageUrl: "https://res.cloudinary.com/cci-global/image/upload/v1673526498/cci-get-dp/production/events/cci-uyo-inaugural-service-banner.png",
    numberOfViews: 105,
    numberOfDps: 104,
    visibility: "PUBLIC",
    avatarShape: "CIRCLE",
    slug: "uyo_inauguration",
    url: "uyo-inauguration",
    description: "<div><p>You prayed for this, dreamt about it and now it's here 🥳🥳🥳</p><p>It's few days to our inaugural service and we're super excited 💃🏿💃🏿💃🏿</p><p>CCI UYO is here 🔥🔥🔥</p><p>Tell a friend to tell a friend 🗣</p><p>Date: <strong>15th January, 2023</strong></p><p>Time: <strong>9 am</strong></p><p>Venue: Silverbird Cinemas Hall 1, Ibom Tropicana Entertainment Centre, Uyo, Akwa Ibom State</p><p><a href=\"https://instagram.com/cci_uyo\" target=\"_blank\">#cciuyoishome</a> <a href=\"https://instagram.com/cci_global\" target=\"_blank\">#cciglobal</a></p></div>",
    imagePosition: {
      x: "238",
      y: "283",
      height: "225",
      width: "225",
      compassPosition: "north_west",
      fontFamily: null,
      fontSize: null,
      fontWeight: null,
      fontStyle: null,
      textDecoration: null,
      textColor: null,
      align: null
    },
    usernamePosition: {
      x: "0",
      y: "198",
      height: "40",
      width: "703",
      compassPosition: "north_west",
      fontFamily: "Expose.ttf",
      fontSize: "28",
      fontWeight: "normal",
      fontStyle: null,
      textDecoration: "uppercase",
      textColor: "white",
      align: "lpad"
    },
    eventDate: "2023-01-15T00:00:00.000Z"
  },
  {
    id: "63c29f5afbd28f4bc9a95521",
    name: "CCI AJAH INAUGURAL SERVICE",
    subtitle: null,
    imageUrl: "https://res.cloudinary.com/cci-global/image/upload/v1673966886/cci-get-dp/production/events/tk8wwokweog0pz74bifi.jpg",
    baseImageUrl: "https://res.cloudinary.com/cci-global/image/upload/v1673966878/cci-get-dp/production/events/yyiwuyyzgdd43zcviaxh.jpg",
    numberOfViews: 119,
    numberOfDps: 84,
    visibility: "PUBLIC",
    avatarShape: "SQUARE",
    slug: "ajah-inauguration",
    url: "ajah-inauguration",
    description: "<div><p>You prayed for this, dreamt about it and now it's here 🥳🥳🥳</p><p>It's few days to our inaugural service and we're super excited 💃🏿💃🏿💃🏿</p><p>CCI AJAH is here 🔥🔥🔥</p><p>Tell a friend to tell a friend 🗣</p><p>Date: <strong>22nd January, 2023</strong></p><p>Time: <strong>10 am</strong></p><p>Venue: 5th & Eden Event Centre, Km 14 Lekki-Epe Expressway, (Beside Auto Parts) by Eleganza Bus Stop, Eti-Osa, Lagos State</p><p><a href=\"https://www.instagram.com/cci_ajah\" target=\"_blank\">#cciajahishome</a> <a href=\"https://instagram.com/cci_global\" target=\"_blank\">#cciglobal</a></p></div>",
    imagePosition: {
      x: "242",
      y: "196",
      height: "268",
      width: "233",
      compassPosition: null,
      fontFamily: null,
      fontSize: null,
      fontWeight: null,
      fontStyle: null,
      textDecoration: null,
      textColor: null,
      align: null
    },
    usernamePosition: {
      x: "210",
      y: "580",
      height: "46",
      width: "232",
      compassPosition: null,
      fontFamily: "Expose.ttf",
      fontSize: "28",
      fontWeight: "normal",
      fontStyle: null,
      textDecoration: "uppercase",
      textColor: "white",
      align: "lpad"
    },
    eventDate: "2023-01-22T18:21:38.017Z"
  },
  {
    id: "63c7d91ea5fb61a59158c56a",
    name: "CCI MARABA INAUGURAL SERVICE",
    subtitle: null,
    imageUrl: "https://res.cloudinary.com/cci-global/image/upload/v1674041627/cci-get-dp/production/events/maraba-banner_ydg3k0.jpg",
    baseImageUrl: "https://res.cloudinary.com/cci-global/image/upload/v1674041628/cci-get-dp/production/events/Mararaba_Inaugural_Service_-_getdp_stohso.jpg",
    numberOfViews: 278,
    numberOfDps: 228,
    visibility: "PUBLIC",
    avatarShape: "CIRCLE",
    slug: "maraba-inauguration",
    url: "maraba-inauguration",
    description: "<div><p>The wait is finally over 🥳🥳 Are you ready for the move of God in Mararaba through @cci__mararaba?<p> <p>   We are excited and ready to see the gospel prevail in Mararaba and its environs.</p> <p style=\"margin:0px;\">   A seat is reserved for you ✅</p>   <p style=\"margin:0px;\">Date has been fixed ✅</p> <p style=\"margin:0px;\">Proper preparation is being put in place to receive you ✅</p> <p>   All you need to do is to show up 😎</p> <p>   Where would you be on the <strong>22nd of January, 2023</strong>???</p>   <p><a href=\"https://www.instagram.com/cci__mararaba\" target=\"_blank\">#ccimararaba</a> <a href=\"https://instagram.com/cci_global\" target=\"_blank\">#cciglobal</a></p> </div>",
    imagePosition: {
      x: "65",
      y: "78",
      height: "197",
      width: "197",
      compassPosition: null,
      fontFamily: null,
      fontSize: null,
      fontWeight: null,
      fontStyle: null,
      textDecoration: null,
      textColor: null,
      align: null
    },
    usernamePosition: {
      x: "288",
      y: "146",
      height: "46",
      width: "274",
      compassPosition: null,
      fontFamily: "Expose.ttf",
      fontSize: "28",
      fontWeight: "normal",
      fontStyle: null,
      textDecoration: "uppercase",
      textColor: "white",
      align: "lpad"
    },
    eventDate: "2023-01-22T20:48:19.595Z"
  },
  {
    id: "63d3e67c8ee8cc855f4bcc7c",
    name: "CCI LOKOGOMA INAUGURAL SERVICE",
    subtitle: "Opique Event Centre, Before Sun City, off Galadimawa Roundabout, Rign Rd 2, Kaura, Abuja",
    imageUrl: "https://res.cloudinary.com/cci-global/image/upload/v1674831480/cci-get-dp/production/events/cci_lokogoma_lfrght.jpg",
    baseImageUrl: "https://res.cloudinary.com/cci-global/image/upload/v1674831483/cci-get-dp/production/events/cci_attendace_Lokogoma__1_vh12cy.jpg",
    numberOfViews: 142,
    numberOfDps: 41,
    visibility: "PUBLIC",
    avatarShape: "CIRCLE",
    slug: "cci-lokogoma-inaugural-service",
    url: "lokogoma-inauguration",
    description: "<div> <p>The wait is finally over 🥳🥳</p>   <p>Are you ready for the move of God in Lokogoma through @cci__lokogoma?</p>    <p>We are excited and ready to see the gospel prevail in Lokogoma and its environs.</p>    <ul>     <li>A seat is reserved for you ✅</li>     <li>Date has been fixed ✅</li>     <li>Proper preparation is being put in place to receive you ✅</li></ul><p>All you need to do is to show up 😎</p><p>Where would you be on the 29th of January, 2023???</p>    <p><a href=\"https://www.instagram.com/cci_lokogoma/\" target=\\\"_blank\">#ccilokogoma</a> <a href=\"https://www.instagram.com/cci_global/\" target=\"_blank\">#cciglobal</a> <a href=\"https://www.instagram.com/cci_abuja/\" target=\"_blank\">#cciabuja</a></p> </div>",
    imagePosition: {
      x: "106",
      y: "118",
      height: "183",
      width: "183",
      compassPosition: null,
      fontFamily: null,
      fontSize: null,
      fontWeight: null,
      fontStyle: null,
      textDecoration: null,
      textColor: null,
      align: null
    },
    usernamePosition: {
      x: "325",
      y: "194",
      height: "46",
      width: "283",
      compassPosition: null,
      fontFamily: "Expose.ttf",
      fontSize: "28",
      fontWeight: null,
      fontStyle: null,
      textDecoration: "uppercase",
      textColor: "white",
      align: "lpad"
    },
    eventDate: "2023-01-29T10:48:54.145Z"
  },
  {
    id: "63db834f1a9a68e9909263e4",
    name: "CCI ABEOKUTA INAUGURAL SERVICE",
    subtitle: "55 LOUNGE, PIZZA & PASTRIES, OMIDA ROAD, OKE ILEWO, ABEOKUTA",
    imageUrl: "https://res.cloudinary.com/cci-global/image/upload/v1675330378/cci-get-dp/production/events/cci_abeokuta_spcukd.png",
    baseImageUrl: "https://res.cloudinary.com/cci-global/image/upload/v1675330381/cci-get-dp/production/events/Getdp_Banner_for_Abeokuta_rwwma0.jpg",
    numberOfViews: 142,
    numberOfDps: 46,
    visibility: "PUBLIC",
    avatarShape: "SQUARE",
    slug: "cci-abeokuta-inaugural-service",
    url: "abeokuta-inauguration",
    description: "<div>   <p>You prayed for it, Waited for it, Dreamt about it.</p>  <p>And it's finally here!</p>  <p>Join us  for our inaugural service<p>    <ul style=\"list-style: none\">     <li class=\"mb-2\">🗓️ 5th February, 2023</li>     <li class=\"mb-2\">🕐 10 am</li>     <li class=\"mb-2\">📍 55 LOUNGE, PIZZA & PASTRIES, OMIDA ROAD, OKE ILEWO, ABEOKUTA</li>     </ul>  <p>Tag a friend you'd be coming along with</p>    <p><a href=\"https://www.instagram.com/cci_abeokuta/\" target=\"_blank\" class=\"hover:underline\">#cciabkishere</a> <a href=\"https://www.instagram.com/cci_global/\" target=\"_blank\" class=\"hover:underline\">#cciglobal</a></p> </div>",
    imagePosition: {
      x: "211",
      y: "238",
      height: "282",
      width: "282",
      compassPosition: null,
      fontFamily: null,
      fontSize: null,
      fontWeight: null,
      fontStyle: null,
      textDecoration: null,
      textColor: null,
      align: null
    },
    usernamePosition: {
      x: "87",
      y: "580",
      height: "46",
      width: "526",
      compassPosition: null,
      fontFamily: null,
      fontSize: null,
      fontWeight: null,
      fontStyle: null,
      textDecoration: null,
      textColor: "white",
      align: null
    },
    eventDate: "2023-02-05T01:49:03.571Z"
  },
  {
    id: "6449c780b630e96b2518a8ca",
    name: "CCI Ago - DEEPER",
    subtitle: "Hillcrest Event Center, 46 Ago Palace Way, Lagos, Nigeria.",
    imageUrl: "https://res.cloudinary.com/cci-global/image/upload/v1682556387/cci-get-dp/production/events/deeper-ago-main.jpg",
    baseImageUrl: "https://res.cloudinary.com/cci-global/image/upload/v1682556387/cci-get-dp/production/events/deeper-ago-getdp.jpg",
    description: "<div><p>Time to go DEEPER!! 🔥🔥🔥</p><p>CCI Ago are you ready ?</p><p>Our Apostle <a href=\"https://instagram.com/pst_iren\" target=\"_blank\">@pst_iren</a> will be live with us for the first ever Deeper <a href=\"https://instagram.com/cci_ago\" target=\"_blank\">@cci_ago</a>!</p><p>Date is May 1st, 2023.</p><p>Get ready to be transformed and encounter a deeper shift in your consecration & devotion.</p><p>Pray and plan to attend. Your life is about to change forever!</p><p>Spread the word! Tag who must not miss this 🥳</p></div>",
    numberOfViews: 164,
    numberOfDps: 98,
    tags: [
      "#cci_ago",
      "#deeper",
      "#cci_global"
    ],
    visibility: "PUBLIC",
    cta: null,
    avatarShape: "CIRCLE",
    createdAt: "2023-04-27T00:53:20.563Z",
    updatedAt: "2023-04-27T00:58:19.437Z",
    slug: "cci-ago-deeper",
    url: "deeper-ago",
    imagePosition: {
      x: "143",
      y: "98",
      height: "417",
      width: "417",
      compassPosition: "north_west",
      fontFamily: null,
      fontSize: null,
      fontWeight: null,
      fontStyle: null,
      textDecoration: null,
      textColor: null,
      align: null
    },
    usernamePosition: {
      x: "336",
      y: "551",
      height: "50",
      width: "317",
      compassPosition: "north_west",
      fontFamily: "Expose.ttf",
      fontSize: "30",
      fontWeight: "normal",
      fontStyle: null,
      textDecoration: "uppercase",
      textColor: "red",
      align: "lpad"
    },
    category: null,
    eventDate: "2023-05-01T00:00:00.000Z",
    createdBy: null
  },
  {
    id: "9677a987d866cd94994a86c6",
    name: "DEEPER - Lagos",
    subtitle: "Queens Park Event Centre, Water Corporation Drive, off Ligali Ayorinde Street, VI, Lagos, Nigeria.",
    imageUrl: "https://res.cloudinary.com/cci-global/image/upload/v1686676890/cci-get-dp/production/events/deeper-lagos-main.png",
    baseImageUrl: "https://res.cloudinary.com/cci-global/image/upload/v1686676890/cci-get-dp/production/events/deeper-lagos-getdp-banner.jpg",
    description: "<div><p>Deeper Lagos is happening on June 29th, 2023!</p><p>Have you marked your calendar?</p><p>Made plans to attend?</p><p>Documented your expectations?</p><p>Told a friend / relative / acquaintance / stranger / colleague about Deeper Lagos?</p><p>Are you stirring up yourself in prayer ahead of this life transforming meeting?</p><p>Yes?</p> <p>Then let's go deeper</p><p>Stay tuned for more details 💃🏻</p></div>",
    numberOfViews: 173,
    numberOfDps: 170,
    tags: [
      "#cci_lagos",
      "#deeper",
      "#cci_global"
    ],
    visibility: "PUBLIC",
    cta: null,
    avatarShape: "CIRCLE",
    createdAt: "2023-06-15T01:47:44.228Z",
    updatedAt: "2023-06-15T01:47:44.228Z",
    slug: "deeper-lagos",
    url: "deeper-lagos",
    imagePosition: {
      x: "227",
      y: "86",
      height: "262",
      width: "262",
      compassPosition: "north_west",
      fontFamily: null,
      fontSize: null,
      fontWeight: null,
      fontStyle: null,
      textDecoration: null,
      textColor: null,
      align: null
    },
    usernamePosition: {
      x: "304",
      y: "348",
      height: "40",
      width: "162",
      compassPosition: "north_west",
      fontFamily: "Expose.ttf",
      fontSize: "22",
      fontWeight: "normal",
      fontStyle: null,
      textDecoration: "uppercase",
      textColor: "black",
      align: "lpad"
    },
    category: null,
    eventDate: "2023-06-29T00:00:00.000Z",
    createdBy: null
  },
  {
    id: "9677a987d866cd4746389544",
    name: "The Word & The Spirit - Port Harcourt",
    subtitle: "Convocation Arena, University of Port Harcourt, Port Harcourt, Rivers, Nigeria.",
    imageUrl: "https://res.cloudinary.com/cci-global/image/upload/v1687281605/cci-get-dp/production/events/ph-word-n-spirit-main.jpg",
    baseImageUrl: "https://res.cloudinary.com/cci-global/image/upload/v1687281604/cci-get-dp/production/events/ph-word-n-spirit-getdp-banner.jpg",
    description: "<div><p>You asked for it and God delivered!</p><p>Prepare to be blown away as we unveil the extraordinary at the first ever <a href=\"https://instagram.com/cci_portharcourt\" target=\"_blank\">@cci_portharcourt</a> outreach in the University of Port Harcourt. 🥳🥳🥳</p> <p>Get ready for an awe-inspiring experience where THE WORD AND THE SPIRIT converge in miraculous ways. Brace yourself for divine encounters, supernatural breakthroughs, and a faith journey like never before.</p> <p>Don't miss out on what God has in store for you!</p> <p>Come expectant</p><p>Come praying</p><p>Come with someone</p></div>",
    numberOfViews: 0,
    numberOfDps: 0,
    tags: [
      "#cci_portharcourt",
      "#uniport",
      "#cci_global"
    ],
    visibility: "PUBLIC",
    cta: null,
    avatarShape: "SQUARE",
    createdAt: "2023-06-20T01:47:44.228Z",
    updatedAt: "2023-06-20T01:47:44.228Z",
    slug: "the-word-the-spirit-port-harcourt",
    url: "uniportinvasion",
    imagePosition: {
      x: "46",
      y: "92",
      height: "323",
      width: "303",
      compassPosition: "north_west",
      fontFamily: null,
      fontSize: null,
      fontWeight: null,
      fontStyle: null,
      textDecoration: null,
      textColor: null,
      align: null
    },
    usernamePosition: null,
    category: null,
    eventDate: "2023-06-23T14:00:00.000Z",
    createdBy: null
  },
  {
    id: "9677a987d8628f4bc9a95521",
    name: "DEEPER - Uyo",
    subtitle: "6 Goodluck Jonathan Boulevard, New Stadium Road, Uyo, Akwa Ibom, Nigeria",
    imageUrl: "https://res.cloudinary.com/cci-global/image/upload/v1687281604/cci-get-dp/production/events/deeper-uyo-main.jpg",
    baseImageUrl: "https://res.cloudinary.com/cci-global/image/upload/v1687281604/cci-get-dp/production/events/deeper-uyo-getdp-banner.jpg",
    description: "<div><p>Something extraordinary is happening in the city of Uyo!</p><p>Are you ready to dive deeper????? To explore the depths of your faith and encounter God?</p><p>Mark your calendars and get ready. It's time to dig deep and experience God like never before. Don't miss out!</p><p>Deeper Uyo is coming, Apostle is Coming 💃💃💃💃</p><p>Make it a date!</p></div>",
    numberOfViews: 0,
    numberOfDps: 0,
    tags: [
      "#cci_uyo",
      "#deeper",
      "#cci_global"
    ],
    visibility: "PUBLIC",
    cta: null,
    avatarShape: "CIRCLE",
    createdAt: "2023-06-20T01:47:44.228Z",
    updatedAt: "2023-06-20T01:47:44.228Z",
    slug: "deeper-uyo",
    url: "deeper-uyo",
    imagePosition: {
      x: "220",
      y: "83",
      height: "252",
      width: "263",
      compassPosition: "north_west",
      fontFamily: null,
      fontSize: null,
      fontWeight: null,
      fontStyle: null,
      textDecoration: null,
      textColor: null,
      align: null
    },
    usernamePosition: {
      x: "270",
      y: "346",
      height: "40",
      width: "240",
      compassPosition: "north_west",
      fontFamily: "Expose.ttf",
      fontSize: "26",
      fontWeight: "normal",
      fontStyle: null,
      textDecoration: "uppercase",
      textColor: "white",
      align: "lpad"
    },
    category: null,
    eventDate: "2023-07-02T08:00:00.000Z",
    createdBy: null
  },
  {
    id: "9677a987d8628f7c8ee8cc85",
    name: "CCI Akure Inaugural Service",
    subtitle: "Ruby's Court Events Hall, Oke-Ijebu Road, Akure, Ondo, Nigeria",
    imageUrl: "https://res.cloudinary.com/cci-global/image/upload/v1689126206/cci-get-dp/production/events/akure-inauguration-main.png",
    baseImageUrl: "https://res.cloudinary.com/cci-global/image/upload/v1689126206/cci-get-dp/production/events/akure-inauguration-getdp-banner.jpg",
    description: "<div><p>You’ve prayed for this and it’s finally here!</p><p>Get ready for the inaugural service of, wait for it… CCI AKURE 💃🏻💃🏻💃🏻🕺🏾🕺🏾</p><p>Tell a friend to tell a friend in Akure that CCI is comingggg</p><p><a href=\"https://instagram.com/cci_akure\" target=\"_blank\">#CCIAkure</a> <a href=\"https://instagram.com/cci_global\" target=\"_blank\">#CCIGlobal</a></p></div>",
    numberOfViews: 0,
    numberOfDps: 0,
    tags: [
      "#cci_akure",
      "#inauguration",
      "#cci_global"
    ],
    visibility: "PUBLIC",
    cta: null,
    avatarShape: "CIRCLE",
    createdAt: "2023-07-11T02:47:44.228Z",
    updatedAt: "2023-07-11T02:47:44.228Z",
    slug: "cci-akure-inaugural-service",
    url: "akure-inauguration",
    imagePosition: {
      x: "213",
      y: "126",
      height: "278",
      width: "278",
      compassPosition: "north_west",
      fontFamily: null,
      fontSize: null,
      fontWeight: null,
      fontStyle: null,
      textDecoration: null,
      textColor: null,
      align: null
    },
    usernamePosition: {
      x: "325",
      y: "435",
      height: "40",
      width: "200",
      compassPosition: "north_west",
      fontFamily: "Expose.ttf",
      fontSize: "26",
      fontWeight: "normal",
      fontStyle: null,
      textDecoration: "uppercase",
      textColor: "white",
      align: "lpad"
    },
    category: null,
    eventDate: "2023-07-16T08:00:00.000Z",
    createdBy: null
  }
];

export default banners;
